/**
 * Resolve the teaser text to render inside a card (CARD-02).
 *
 * Fallback order:
 *   1. `entry.cardDescription` (trimmed, if non-empty)
 *   2. `entry.seo.metaDescription` (trimmed, if non-empty)
 *   3. `null` — so consumers can suppress the teaser node with `@if (data().body)`
 *
 * Returns `null` (never `''`) so that `@if` in card-item.html skips the element
 * entirely instead of rendering an empty `<p>`.
 *
 * No JS-side truncation: the spec relies on the Strapi 200-char field cap plus
 * CSS clamp at render time.
 */
export function resolveCardTeaser(
  entry:
    | {
        cardDescription?: string | null;
        seo?: { metaDescription?: string | null } | null;
      }
    | null
    | undefined,
): string | null {
  if (!entry) return null;
  const direct = entry.cardDescription?.trim();
  if (direct) return direct;
  const fallback = entry.seo?.metaDescription?.trim();
  return fallback || null;
}
